import '@babel/polyfill';
import CreatSystem from './lib/main';
import asyncRouterMap from './router/asyncRoutes';

window.manageShell = { default: CreatSystem };

const routeFilter = (routes, allRoute) => {
  if (allRoute && allRoute.length) {
    let addRoute = manageShell.default.utils.route.formatRouteLink(allRoute);
    for (let index = 0; index < addRoute.length; index++) {
      const element = addRoute[index];
      if (element.children) {
        routes = routes.concat(element.children);
      } else if (
        element.menuCode === process.env.VUE_APP_REGISTER_DASHBOARD_CODE
      ) {
        routes.unshift(element);
      }
    }
  }
  return {
    allRoute,
    routes,
  };
};

const getRoute = () => {
  const customerRoute = require('dcxy-customer-manage-static').default;
  const baseRoute = require('dcxy-base-manage-static').default;
  const systemRoute = require('dcxy-system-manage-static').default;
  const deviceRoute = require('dcxy-device-manage-static').default;
  const statisticsRoute = require('dcxy-statistics-manage-static').default;
  const smaproRoute = require('dcxy-smapro-manage-static').default;
  const customerOperRoute = require('dcxy-customer-operate-static').default;
  const taskRoute = require('dcxy-task-manage-static').default;

  return [
    ...customerRoute,
    ...baseRoute,
    ...systemRoute,
    ...deviceRoute,
    ...statisticsRoute,
    ...smaproRoute,
    ...customerOperRoute,
    ...taskRoute,
  ];
};

manageShell.default.createSystem({
  basePath: process.env.VUE_APP_BASE_URL,
  routers: [...asyncRouterMap, ...getRoute()],
  routeFilter: routeFilter,
});
